import React, { useState, useEffect } from 'react';
import FourPillars from '../components/FourPillars';

const ManufacturingPage = () => {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        'why-choose',
        'solutions',
        'key-benefits'
      ];
      
      const scrollPosition = window.scrollY + 150;
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setActiveSection(sectionId);
    }
  };

  return (
    <main className="services">
      <div className="container">
        <div className="sv-content-wrapper">
          <div className="sv-main-content">
            {/* Hero */}
            <section className="sv-hero">
              <div className="sv-eyebrow">Manufacturing</div>
              <h1 className="sv-title">Industrial Asset Recovery Solutions for Manufacturing</h1>
              <p className="sv-subtitle">Specialized solutions for manufacturing operations to handle excess raw materials, components, finished goods, and industrial equipment. Optimize supply chain efficiency and recover value from surplus assets.</p>
            </section>

            {/* Why Choose */}
            <section id="why-choose" className="sv-features">
              <h2 className="sv-section-title">Why Manufacturing Companies Choose Us</h2>
        <div className="sv-features-grid">
          <div className="sv-feature">
            <h4>Industrial Expertise</h4>
            <p>Specialized knowledge of manufacturing processes, materials, and equipment for optimal asset recovery.</p>
          </div>
          <div className="sv-feature">
            <h4>Supply Chain Optimization</h4>
            <p>Streamline supply chain by disposing of excess materials, components, and finished goods efficiently.</p>
          </div>
          <div className="sv-feature">
            <h4>Compliance & Safety</h4>
            <p>Ensure compliance with industrial regulations, safety standards, and environmental requirements.</p>
          </div>
          <div className="sv-feature">
            <h4>Value Recovery</h4>
            <p>Maximize recovery from industrial assets through strategic routing to secondary markets and recycling.</p>
          </div>
        </div>
      </section>

            {/* Solutions */}
            <section id="solutions" className="sv-overview">
              <h2 className="sv-section-title">Solutions for Manufacturing</h2>
        <ul className="sv-bullets sv-list">
          <li>Raw Materials Disposition – Dispose of excess raw materials, components, and industrial supplies</li>
          <li>Finished Goods Liquidation – Liquidate excess finished goods and overstock inventory</li>
          <li>Industrial Equipment – Handle disposition of manufacturing equipment and machinery</li>
          <li>Supply Chain Optimization – Streamline supply chain by removing obsolete and excess materials</li>
          <li>Compliance Support – Ensure compliance with industrial regulations and environmental standards</li>
          <li>Facility Closures – Complete liquidation of manufacturing facilities and assets</li>
        </ul>
      </section>

            {/* Benefits */}
            <section id="key-benefits" className="sv-overview">
              <h2 className="sv-section-title">Key Benefits</h2>
        <ul className="sv-bullets sv-list">
          <li>Optimize supply chain efficiency by removing excess inventory</li>
          <li>Recover value from surplus materials, components, and finished goods</li>
          <li>Ensure compliance with industrial regulations and safety standards</li>
          <li>Free up warehouse and production space</li>
          <li>Reduce storage costs and operational overhead</li>
          <li>Gain detailed reporting and documentation for compliance</li>
        </ul>
      </section>

            {/* Four Pillars */}
            <FourPillars />

            {/* CTA */}
            <section className="sv-cta">
              <div className="sv-cta-inner">
                <h3>Ready to optimize your manufacturing operations?</h3>
                <p>Get a free assessment and discover how we can streamline your supply chain and recover value.</p>
                <div className="sv-cta-actions">
                  <a className="btn btn-primary" href="tel:+18778739336">Call (877) 873-9336</a>
                  <a className="btn btn-secondary" href="mailto:info@globoflo.com">Email Us</a>
                </div>
              </div>
            </section>
          </div>

          {/* Quick Links Sidebar */}
          <aside className="sv-quick-links">
            <h3 className="sv-quick-links-title">Manufacturing</h3>
            <nav className="sv-quick-links-nav">
              <ul>
                <li>
                  <button 
                    className={activeSection === 'why-choose' ? 'active' : ''}
                    onClick={() => scrollToSection('why-choose')}
                  >
                    Why Manufacturing Companies Choose Us
                  </button>
                </li>
                <li>
                  <button 
                    className={activeSection === 'solutions' ? 'active' : ''}
                    onClick={() => scrollToSection('solutions')}
                  >
                    Solutions for Manufacturing
                  </button>
                </li>
                <li>
                  <button 
                    className={activeSection === 'key-benefits' ? 'active' : ''}
                    onClick={() => scrollToSection('key-benefits')}
                  >
                    Key Benefits
                  </button>
                </li>
              </ul>
            </nav>
          </aside>
        </div>
      </div>
    </main>
  );
};

export default ManufacturingPage;

